module.exports = __webpack_public_path__ + "ma.842a8773ec185519cfdf.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ma.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ma.svg
// module chunks = styles